<template>
	<div class="ModuleBoxResetPassword" v-if="Visible">
		<div class="ModuleBoxResetPasswordBody">
			<div class="ModuleBoxResetPasswordBodyTop">
				<div class="ModuleBoxResetPasswordBodyTopLogo">
					<el-image :src="ImageLogoUrl" fit="scale-down" />
				</div>
				<div class="ModuleBoxResetPasswordBodyTopCloseBtn" @click="onHide()">
					<el-icon><Close /></el-icon>
				</div>
			</div>
			<div class="ModuleBoxResetPasswordBodyBody">
				<div class="ModuleBoxResetPasswordBodyBodyBody">
					<el-form 
						:model="ResetPasswordForm" 
						:rules="ResetPasswordRules" 
						ref="ResetPasswordFormRef" 
						label-width="0"
					>
						<div class="ModuleBoxResetPasswordBodyBodyBodyScrollbar">
							<el-scrollbar>
								<div class="ModuleBoxResetPasswordBodyBodyBodyItem" style="width: 100%;">
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemTitle">登录账号</div>
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemBody">
										<el-form-item prop="Username">
											<el-input v-model="ResetPasswordForm.Username" placeholder="请输入登录账号" />
										</el-form-item>
									</div>
								</div>
								<div class="ModuleBoxResetPasswordBodyBodyBodyItem">
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemTitle">手机号码</div>
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemBody">
										<el-form-item prop="Phone">
											<el-input v-model="ResetPasswordForm.Phone" placeholder="请输入手机号码" />
										</el-form-item>
									</div>
								</div>
								<div class="ModuleBoxResetPasswordBodyBodyBodyItem">
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemTitle">电子邮箱</div>
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemBody">
										<el-form-item prop="Email">
											<el-input v-model="ResetPasswordForm.Email" placeholder="请输入电子邮箱" />
										</el-form-item>
									</div>
								</div>
								<!-- <div class="ModuleBoxResetPasswordBodyBodyBodyLine">
									<div class="ModuleBoxResetPasswordBodyBodyBodyLineBody"></div>
								</div> -->
								<div class="ModuleBoxResetPasswordBodyBodyBodyItem">
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemTitle">新密码</div>
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemBody">
										<el-form-item prop="Password">
											<el-input type="password" v-model="ResetPasswordForm.Password" placeholder="请输入新密码" />
										</el-form-item>
									</div>
								</div>
								<div class="ModuleBoxResetPasswordBodyBodyBodyItem">
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemTitle">确认密码</div>
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemBody">
										<el-form-item prop="Password2">
											<el-input type="password" v-model="ResetPasswordForm.Password2" placeholder="请输入确认密码" />
										</el-form-item>
									</div>
								</div>
								<div class="ModuleBoxResetPasswordBodyBodyBodyItem">
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemTitle">验证码</div>
									<div class="ModuleBoxResetPasswordBodyBodyBodyItemBody" style="display: flex;">
										<el-form-item prop="Captcha" style="width: 100%;">
											<el-input v-model="ResetPasswordForm.Captcha" placeholder="请输入验证码" />
										</el-form-item>
										<div class="ModuleBoxResetPasswordBodyBodyBodyItemBodyCaptcha" @click="ResetCaptcha()">
											<Sidentify ref="Captcha" :identifyCode="CaptchaValue"></Sidentify>
										</div>
									</div>
								</div>
							</el-scrollbar>
						</div>
						<div class="ModuleBoxResetPasswordBodyBodyBodyButton">
							<div class="ModuleBoxResetPasswordBodyBodyBodyButtonResetPasswordBtn" @click="ResetPasswordSubmit()">提交重置</div>
							<div class="ModuleBoxResetPasswordBodyBodyBodyButtonBackBtn" @click="onBack()">我记得密码，直接登录</div>
						</div>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>
